import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { GoArrowUpRight } from "react-icons/go";

import SendModal from "./SentModal";
import ReceiveModal from "./RecivedModal";
import WalletTableSkeleton from "./WalletTableSkeleton";
import { FiEye, FiEyeOff } from "react-icons/fi";
import DynamicHeader from "../Header/DynamicHeader";

export default function WalletDetail() {
  const [showMainnet, setShowMainnet] = useState(false);
  const [showTestnet, setShowTestnet] = useState(true);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [isReceiveModalOpen, setIsReceiveModalOpen] = useState(false);
  const [portfolioNetworth, setPortfolioNetworth] = useState(null);
  const [allTokenBalances, setAllTokenBalances] = useState([]);
  const [evmBalance, setEvmBalance] = useState(0);
  const [isAPILoading, setIsAPILoading] = useState(true);
  const [showBalance, setShowBalance] = useState(true);


const [balanceViewIndex, setBalanceViewIndex] = useState(0);
const balanceViewOptions = [
  "balance",        
  "usd_value",       
  "totalUsdValue"   
];
const getDynamicBalance = () => {
 
  if (!selectedToken) {
 
    return portfolioNetworth
      ? `Total USD: $${Number(portfolioNetworth).toFixed(8)}`
      : "Total USD";
  }

 
  const key = balanceViewOptions[balanceViewIndex];
  if (key === "totalUsdValue") {
    return portfolioNetworth
      ? `Total USD: $${Number(portfolioNetworth).toFixed(8)}`
      : "Total USD";
  }
  if (selectedToken[key] !== undefined) {
    if (key === "balance") return `Balance: ${selectedToken.balance}`;
    if (key === "usd_value") return `USD Value: $${Number(selectedToken.usd_value).toFixed(5)}`;
    return selectedToken[key];
  }
  return "--";
};

  
  const { activeNetwork, token } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const nativeToken = activeNetwork?.nativeCurrency?.symbol || "ETH";

  const [selectedToken, setSelectedToken] = useState(null);

  const getNetworkName = (chainId) => {
    switch (chainId) {
      case 103: return "Solana DevNet";
      case 101: return "Solana MainNet";
      case 43113: return "Avalanche Fuji";
      case 43114: return "Avalanche Mainnet";
      case 97: return "BSC Testnet";
      case 56: return "BSC Mainnet";
      case 80002: return "Polygon Amoy";
      case 137: return "Polygon";
      case 11155111: return "Sepolia Testnet";
      case 1: return "Ethereum Mainnet";
      default: return "Unknown Network";
    }
  };

  const groupBalancesByChain = (balances) => {
    const grouped = {};
    balances.forEach((token) => {
      const chainId = token.chainId;
      if (!grouped[chainId]) {
        grouped[chainId] = { chainId, balances: [] };
      }
      grouped[chainId].balances.push(token);
    });
    return Object.values(grouped);
  };

  const fetchPortfolio = async () => {
    const headers = { authorization: `Bearer ${token}` };
    try {
      setIsAPILoading(true); 
      const response = await axios.get("https://looknatest.com/wallet/wallet/getAllChainAssets", { headers });
      if (response.status === 200) {
        const data = response.data;
        const groupedBalances = groupBalancesByChain(data?.balances || []);
        setAllTokenBalances(groupedBalances);
        setPortfolioNetworth(data?.totalUsdValue || 0);
        setEvmBalance(data?.nativeEquivalent || 0);
      }
    } catch (error) {
      console.error("Error fetching portfolio:", error);
      toast.error(error?.response?.data?.error || "Failed to fetch portfolio");
      if (error?.response?.status === 403) {
        navigate("/connect-wal");
      }
    } finally {
      setIsAPILoading(false); 
    }
  };

  const fetchNetworkMode = async () => {
    try {
      const response = await axios.get("https://looknatest.com/wallet/wallet/checkNetworkMode", {
        headers: { authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setShowMainnet(response.data?.showMainnet);
        setShowTestnet(response.data?.showTestnet);
      }
    } catch (err) {
      console.error("Failed to check network mode:", err);
    }
  };

  const handleToggleNetworkSelection = async () => {
    try {
      const updatedShowTestnet = !showTestnet;
      const updatedShowMainnet = !showMainnet;

      const response = await axios.post(
        "https://looknatest.com/wallet/wallet/switchNetworks",
        { showTestnet: updatedShowTestnet, showMainnet: updatedShowMainnet },
        { headers: { authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        setShowMainnet(updatedShowMainnet);
        setShowTestnet(updatedShowTestnet);
        toast.success(`Switched to ${updatedShowTestnet ? "Testnet" : "Mainnet"} mode`);
        fetchPortfolio();
      }
    } catch (error) {
      console.error("Error switching network:", error);
      toast.error("Failed to switch network mode");
    }
  };

  useEffect(() => {
    if (token) {
      fetchNetworkMode();
      fetchPortfolio();
    }
  }, [activeNetwork, token]);

  const handleToggleReceiveModal = () => setIsReceiveModalOpen(!isReceiveModalOpen);
  const handleToggleSendModal = () => setIsSendModalOpen(!isSendModalOpen);

  const getBalance = () => {
  if (!showBalance) return "••••••••••";
  if (selectedToken === "USDT") {
    return portfolioNetworth
      ? `USD $ ${portfolioNetworth.toFixed(8)}`
      : "USD";
  } else {
    return `${nativeToken} ${Number(evmBalance)}`;
  }
};

  return (
    <div className="wallett-container">
     
<DynamicHeader/>
      <div className="wallett-actions">
        <button className="wallett-button wallett-send" onClick={handleToggleSendModal}>
          Send <GoArrowUpRight />
        </button>
        <button className="wallett-button wallett-receive" onClick={handleToggleReceiveModal}>
          Receive
        </button>
        <button className="wallett-button wallett-receive" onClick={() => navigate("/history")}>
          Transactions
        </button>
          <button className="wallett-button wallett-receive" onClick={fetchPortfolio}>
          Refresh
        </button>
     <div className="network-selection-container">
  <select
    className="wallett-select wallett-network-toggle"
    value={showTestnet ? "testnet" : "mainnet"}
    onChange={async (e) => {
      const selected = e.target.value;
      const updatedShowTestnet = selected === "testnet";
      const updatedShowMainnet = selected === "mainnet";

      try {
        const response = await axios.post(
          "https://looknatest.com/wallet/wallet/switchNetworks",
          { showTestnet: updatedShowTestnet, showMainnet: updatedShowMainnet },
          { headers: { authorization: `Bearer ${token}` } }
        );

        if (response.status === 200) {
          setShowMainnet(updatedShowMainnet);
          setShowTestnet(updatedShowTestnet);
          toast.success(`Switched to ${updatedShowTestnet ? "Testnet" : "Mainnet"} mode`);
          fetchPortfolio();
        }
      } catch (error) {
        console.error("Error switching network:", error);
        toast.error("Failed to switch network mode");
      }
    }}
  >
    <option value="testnet">Testnet Mode</option>
    <option value="mainnet">Mainnet Mode</option>
  </select>

</div>
      </div>

      {isAPILoading ? (
        <WalletTableSkeleton />
      ) : (
        <>
        <div className="wallett-balance">
  <div
    className="wallett-balance-amount"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }}
  >
    <span
      style={{
        cursor: selectedToken ? "pointer" : "default",
        userSelect: "none"
      }}
      onClick={() => {
        if (selectedToken) setBalanceViewIndex((v) => (v + 1) % balanceViewOptions.length);
      }}
      title={selectedToken ? "Click to switch balance view" : ""}
    >
      <span style={{
        fontFamily: "'Work Sans', sans-serif",
        fontSize: "20px",
        marginLeft: "10px"
      }}>
        BALANCE
      </span>
      &nbsp;{showBalance ? getDynamicBalance() : "••••••••••"}
    </span>
    <span
      style={{ marginTop: "15px", cursor: "pointer" }}
      onClick={() => setShowBalance((v) => !v)}
      title={showBalance ? "Hide balance" : "Show balance"}
    >
      {showBalance ? <FiEye size={20} /> : <FiEyeOff size={20} />}
    </span>
  </div>
  {selectedToken && (
    <div style={{ color: "#BE6BED", marginTop: 4, marginLeft: 14, fontSize: 12, whiteSpace: "nowrap", overflowX: "auto", display: "block"}}>
      {selectedToken.name || selectedToken.symbol}
      <button
        style={{
          background: "transparent",
          border: "none",
          color: "#BE6BED",
          marginLeft: 10,
          cursor: "pointer",
          fontSize: 12
        }}
        onClick={() => setSelectedToken(null)}
      >Show Portfolio</button>
    </div>
  )}
</div>

          {allTokenBalances.some(chain => chain.balances?.length > 0) ? (
            <div className="wallett-tokens">
              <table className="wallett-table">
                <thead>
                  <tr>
                    <th className="th-hover" style={{ borderBottom: "1px solid #BE6BED" }}>Tokens</th>
                    <th className="th-hover" style={{ borderBottom: "1px solid #BE6BED" }}>Balance</th>
                    <th className="th-hover" style={{ borderBottom: "1px solid #BE6BED" }}>Change</th>
                    <th className="th-hover" style={{ borderBottom: "1px solid #BE6BED" }}>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {allTokenBalances.map((chainData, idx) =>
                    chainData.balances.map((token, tokenIdx) => (
                      
                   <tr
  key={`${idx}-${token.tokenAddress || token.mint || tokenIdx}`}
  style={{ cursor: "pointer", background: selectedToken === token ? "#222" : undefined }}
  onClick={() => setSelectedToken(token)}>

                        <td>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {token?.logo ? (
                              <img
                                src={token?.logo}
                                alt="Token Logo"
                                width={24}
                                height={24}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                }}
                                style={{
                                  width: 24,
                                  height: 24,
                                  objectFit: "contain",
                                  borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <div style={{
                                width: 24,
                                height: 24,  display: "flex", alignItems: "center",  justifyContent: "center",  borderRadius: "50%", background: "#f0f0f0", fontSize: 14,
                              }}>🔠</div>
                            )}
                            <span style={{ color: "white" }}>
                              {token?.symbol?.slice(0, 5) || "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          {token?.balance || 0.0}
                          <br />
                          <span style={{ fontSize: "12px", opacity: 0.8, color: "gold" }}>
                            (${Number(token?.usd_value || token?.tokenValueUsd || 0).toFixed(5)})
                          </span>
                        </td>
                        <td style={{
                          color:
                            parseFloat(token?.usdPrice24hrPercentChange) > 0
                              ? "green"
                              : parseFloat(token?.usdPrice24hrPercentChange) < 0
                              ? "red"
                              : "yellow",
                        }}>
                          {token?.usdPrice24hrPercentChange !== undefined
                            ? `${token.usdPrice24hrPercentChange}%`
                            : "N/A"}
                        </td>
                        <td>${token?.usdPrice || "0.00"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ color: "white", textAlign: "center", marginTop: "2rem" }}>
              No token balances found.
            </div>
          )}
        </>
      )}

      <ReceiveModal isOpen={isReceiveModalOpen} setIsOpen={setIsReceiveModalOpen} onClose={handleToggleReceiveModal} />
      <SendModal isOpen={isSendModalOpen} onClose={handleToggleSendModal} />
    </div>
  );
}
